import type { CreateAgentData } from '../../types';
import type { ScenarioConfig } from './types';

const AGENT_FLAGS: Record<string, keyof CreateAgentData> = {
  address_validation: 'address_validation_enabled',
};

/** System tools without an agent flag (e.g. verify_phone) are enabled by adding them to the scenario. */
export const hasAgentFlag = (systemId: string): boolean => systemId in AGENT_FLAGS;

export const enabledSystemTools = (formData: CreateAgentData): string[] =>
  Object.entries(AGENT_FLAGS)
    .filter(([, flag]) => Boolean(formData[flag]))
    .map(([id]) => id);

export const scenarioUsesSystemTool = (config: unknown, systemId: string): boolean => {
  const tools = (config as ScenarioConfig | null)?.tools;
  return (
    Array.isArray(tools) &&
    tools.some(tool => tool.type === 'system' && tool.enabled && tool.system === systemId)
  );
};
